import { Role } from "../../helpers/role";

export const FinanceRoutes = [
  {
    name: "FinanceRoutes",
    path: `/${Role.Finance}`,
    redirect: `/${Role.Finance}`,
    component: () => import("@/layouts/Layout"),
    children: [
      {
        name: "Home",
        path: "/",
        component: () => import("@/views/finance/PayslipSender"),
        meta: {
          authorize: [Role.Finance],
        },
      },

      {
        name: "PayslipSender",
        path: "payslip-sender",
        component: () => import("@/views/finance/PayslipSender"),
        meta: {
          authorize: [Role.Finance],
        },
      },

      {
        name: "OnlinePaymentValidator",
        path: "online-payment-validator",
        component: () => import("@/views/finance/PaymentValidator"),
        meta: {
          authorize: [Role.Finance],
        },
        // children: [
        //   {
        //     name: "OnlinePaymentValidatorMain",
        //     path: "/",
        //     component: () => import("@/views/finance/PaymentValidator"),
        //     meta: {
        //       authorize: [Role.Finance],
        //     },
        //   },
        //   {
        //     name: "PaymentValidatorDetails",
        //     path: "view",
        //     component: () => import("@/views/finance/PaymentValidatorDetails"),
        //     meta: {
        //       passThrough: true
        //     },
        //   },
        // ],
      },
      {
        name: "OnlinePaymentValidatorDetails",
        path: "online-payment-validator-view/:id",
        component: () => import("@/views/finance/PaymentValidatorDetails"),
        meta: {
          // authorize: [Role.Finance],
          passThrough: true
        },
      },
    ],
  },
];
